var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hvh-flex column overflow-hidden",staticStyle:{"padding":"5px 0px 5px 5px","line-height":"20px"}},[_c('DPDPill',{attrs:{"label":_vm.getValueLabel(_vm.node),"type":_vm.type},on:{"mousedown":function($event){$event.stopPropagation();$event.preventDefault();return _vm.$emit('mousedown', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }